"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const free_regular_svg_icons_1 = require("@fortawesome/free-regular-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
function EducationInfoIcon(_ref) {
  let {
    top,
    left,
    onMouseOver,
    onMouseOut
  } = _ref;
  return (
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    react_1.default.createElement("div", {
      className: styles_module_css_1.default['info-icon'],
      style: {
        top,
        left
      },
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut
    }, react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
      icon: free_regular_svg_icons_1.faQuestionCircle
    }))
  );
}
EducationInfoIcon.propTypes = {
  top: prop_types_1.number,
  left: prop_types_1.number,
  onMouseOver: prop_types_1.func,
  onMouseOut: prop_types_1.func
};
exports.default = EducationInfoIcon;